import { atom } from "jotai";

export interface DebugSheetPayload {
  messageId: string;
  groupId: string;
  conversationId: string;
  canViewLogs: boolean;
  data: Record<string, unknown> | null;
}

export const debugSheetPayloadAtom = atom<DebugSheetPayload | null>(null);
